export default "__VITE_ASSET__DE45AYzp__"